import React, { useState } from 'react';
import { Tabs } from 'antd';
import AiChatSettingsTablePageComponent from './tabs/aiChatSettings/aiChatSettingsTablePage.component';
import AiChatHistoryTablePageComponent from './tabs/aiChatHistoryTablePage/aiChatHistoryTablePage.component';
import AiChatSettingsPerUserTablePageComponent from './tabs/aiChatSettingsPerUser/aiChatSettingsPerUserTablePage.component';
import AiChatStatisticsComponent from './tabs/chatAiStatistics/chatAiStatistics.component';

function AiChatSettingsPageComponent() {
  const [selectedTab, setSelectedTab] = useState('1');
  
  return (
    <div className="statistics-page w100-h100">
      <div className="title">AI Chat</div>

      <div className='statistics'>
        <Tabs activeKey={selectedTab} onChange={(activeKey) => setSelectedTab(activeKey)} destroyInactiveTabPane>
          <Tabs.TabPane tab={"Povijest razgovora"} key="1">
            <AiChatHistoryTablePageComponent />
          </Tabs.TabPane>
          <Tabs.TabPane tab={'Statistike'} key="2">
            <AiChatStatisticsComponent />
          </Tabs.TabPane>
          <Tabs.TabPane tab={"Postavke"} key="3">
            <AiChatSettingsTablePageComponent />
          </Tabs.TabPane>
          <Tabs.TabPane tab={"Postavke po korisnicima"} key="4">
            <AiChatSettingsPerUserTablePageComponent />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
}

export default AiChatSettingsPageComponent;
